<template>
  <div id="app" class="main">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body{
    width: 100%;
    height: 100%;
    min-width:1024px;
    min-height: 768px;
    box-sizing:content-box;
}
.main{
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/app.vue